import { MAIN_SITE_URL } from '@framework/constants/app';

export const SKIP_CONFIRMATION = 'skipConfirmation';
export const FORCE_AUTHENTICATE = 'forceAuthenticate';
export const DATASITE_REQUEST_DEMO_LINK = `${MAIN_SITE_URL}/en/board-portal/?utm_source=datasite&utm_medium=referral&utm_campaign=ds+app+central`;
